<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="sm" :show="isLoading">
          <div class="m-2">
            <b-row>
              <b-col cols="7">
                <b-form-file
                  ref="inputFileRef"
                  placeholder="Chọn file để import phiếu khảo sát/đánh giá..."
                  drop-placeholder="Drop file here..."
                  accept=".xls, .xlsx"
                  @change="importExcel"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="text-right">
                  <b-button
                  v-show="showTableImport && (isSystemAdmin() || creatable)"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    class="ml-1"
                    @click="handleImportSetOfCriteriaObjects"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="CheckSquareIcon" /> Import
                    </span>
                  </b-button>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-1"
                    @click="downloadFile"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Tải file mẫu
                    </span>
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    class="ml-1"
                    @click="exportExcel"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Xuất excel
                    </span>
                  </b-button>
                  <b-button
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.saveModal
                    variant="success"
                    @click="onCreate"
                    class="ml-1"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm đợt đánh giá
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  row-style-class="vgt-row"
                  styleClass="vgt-table striped bordered"
                  :columns="columns"
                  :rows="setOfCriteriaObjects"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-else-if="props.column.field === 'status'">
                      {{ props.row.status === 1 ? 'Đang hoạt động' : 'Không hoạt động' }}
                    </span>
                    <span v-else-if="props.column.field === 'setOfCriteriaName'">
                      {{ getSetOfCriteriaName(props.row.setOfCriteriaId) }}
                    </span>
                    <span v-else-if="props.column.field === 'evaluateObjectGroupId'">
                      {{ getEvaluateObjectGroup(props.row.evaluateObjectGroupId) }}
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        v-if="updatable"
                        v-b-modal.saveModal
                        variant="primary"
                        class="btn-icon"
                        size="sm"
                        @click="onEdit(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        v-if="deletable"
                        variant="danger"
                        class="btn-icon"
                        style="margin-left: 6px"
                        size="sm"
                        @click="onClose(props.row)"
                        v-b-tooltip.hover title="Đóng đợt khảo sát"
                      >
                      
                        <feather-icon icon="XSquareIcon" />
                      </b-button>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
          <Save
            ref="saveModalRef"
            :item="currentDataSource"
            @succeed="onSucceed"
            @refeshData="onRefeshData"
          />
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, VBTooltip, BFormFile,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import * as XLSX from 'xlsx'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import Save from '@/views/set-of-criteria-objects/SetOfCriteriaObjectSave.vue'
// import { getUser } from '@/auth/utils'
import { STATUSES } from '@/const/status'


export default {
  name: 'EvaluateObjectGroups',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    Save,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    VBTooltip,
    BFormFile,
  },
  data() {
    return {
      // user: getUser(),
      isLoading: false,
      filter: {
        organizationId: null,
        currentPage: 1,
        itemsPerPage: 10,
        code: null,
        name: null,
        evaluateObjectGroupId: null,
        status: null,
        sort: null,
      },
      currentDataSource: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      showTableImport: false,
      tenFile: '',
      filterExport: null,
      columnsExport: [
        {
          label: 'Mã đợt khảo sát/đánh giá',
          field: 'code',
        },
        {
          label: 'Tên đợt khảo sát/đánh giá',
          field: 'name',
        },
        {
          label: 'Nhóm đối tượng thực hiện khảo sát/đánh giá',
          field: 'evaluateObjectGroupName',
        },
        {
          label: 'Tên phiếu khảo sát đánh giá',
          field: 'setOfCriteriaName',
        },
        {
          label: 'Ngày bắt đầu',
          field: 'startDate',
        },
        {
          label: 'Ngày kết thúc',
          field: 'endDate',
        },
        {
          label: 'Trạng thái',
          field: 'status',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      totalRows: 'setOfCriteriaObject/totalRows',
      setOfCriteriaObjects: 'setOfCriteriaObject/setOfCriteriaObjects',
      setOfCriterias: 'setOfCriteriaObject/setOfCriterias',
      evaluateObjectGroups: 'setOfCriteriaObject/evaluateObjectGroups',
      dataResourecesExport: 'setOfCriteriaObject/dataResourecesExport',
    }),
    columns() {
      return [
        {
          label: 'Mã đợt khảo sát/đánh giá',
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Tên đợt khảo sát/đánh giá',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Nhóm đối tượng thực hiện khảo sát/đánh giá',
          field: 'evaluateObjectGroupId',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.evaluateObjectGroups.map(object => ({ value: object.id, text: object.name })),
            placeholder: 'Tất cả',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tên phiếu khảo sát/đánh giá',
          field: 'setOfCriteriaName',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: STATUSES.map(status => ({ value: status.value, text: status.label })),
            placeholder: 'Tất cả',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.EVALUATE_OBJECT_GROUPS)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.EVALUATE_OBJECT_GROUPS)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.EVALUATE_OBJECT_GROUPS)
    },
  },
  async created() {
    this.updateParams({ currentPage: 1, itemsPerPage: 10 })
    await this.begin()
    await this.onLoad()
  },
  methods: {
    isSystemAdmin,
    ...mapMutations({
      setDataSources: 'setOfCriteriaObject/SET_OF_CRITERIA_OBJECTS',
    }),
    ...mapActions({
      getData: 'setOfCriteriaObject/getData',
      deleteData: 'setOfCriteriaObject/deleteData',
      begin: 'setOfCriteriaObject/begin',
      importSetOfCriteriaObjects: 'setOfCriteriaObject/importSetOfCriteriaObjects',
      getDataSourcesExport: 'setOfCriteriaObject/getDataSourcesExport',
    }),
    async onLoad() {
      this.isLoading = true
      try {
        await this.getDataSourcesFromStore()
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        this.setDataSources([])
      } finally {
        this.isLoading = false
      }
    },
    onClose(dataSource) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa <span class="text-danger">${dataSource.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteData(dataSource.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getDataSourcesFromStore()
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    onCreate() {
      this.currentDataSource = undefined
    },
    onEdit(dataSource) {
      const {
        originalIndex,
        vgt_id,
        ...rest
      } = dataSource
      this.currentDataSource = rest
    },
    async handleImportSetOfCriteriaObjects() {
      this.isLoading = true
      try {
        const res = await this.importSetOfCriteriaObjects(this.dataExcel)
        if (res.code === 1) {
          this.showToast('Import thành công', 'CheckIcon', 'success')
          this.resetInputFile()
          await this.getDataSourcesFromStore()
          this.showTableImport = false
        } else {
          this.showToast(res.message, 'XCircleIcon', 'danger', 3000)
          this.resetInputFile()
          this.showTableImport = false
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger', 3000)
        this.resetInputFile()
        this.showTableImport = false
      } finally {
        this.isLoading = false
      }
    },
    showToast(title, icon, variant, autoHideDelay = 1000) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          autoHideDelay,
        },
      })
    },
    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataSourcesFromStore()
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        await this.getData(this.filter)
        const {
          currentPage,
          itemsPerPage,
          ...rest
        } = this.filter
        this.filterExport = rest
        await this.getDataSourcesExport(this.filterExport)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getDataSourcesFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getDataSourcesFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'setOfCriteriaName')) this.updateParams({ setOfCriteriaName: columnFilters.setOfCriteriaName })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      if (Object.hasOwn(columnFilters, 'evaluateObjectGroupId')) this.updateParams({ evaluateObjectGroupId: columnFilters.evaluateObjectGroupId })
      await this.getDataSourcesFromStore()
    },
    getEvaluateObjectGroup(id) {
      return this.evaluateObjectGroups.find(object => object.id === id)?.name
    },
    async onSucceed() {
      await this.getDataSourcesFromStore()
    },
    async onRefeshData() {
      await this.getDataSourcesFromStore()
    },
    getStatusName(id) {
      return id >= 0 ? STATUSES.find(status => status.value === id).label : ''
    },
    getSetOfCriteriaName(id) {
      return this.setOfCriterias.find(setOfCriteria => setOfCriteria.id === id)?.name
    },
    async importExcel(e) {
      const { files } = e.target
      if (!files.length) {
        return
      } if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        // show err
      }
      if (files[0].name) {
        this.tenFile = files[0].name
      }
      const checkFileData = this.readFile(files)
      if (checkFileData && !checkFileData.status) {
        this.showToast('Có lỗi xảy ra', 'XCircleIcon', 'danger')
      }
    },
    readFile(files) {
      const res = {
        status: true,
        index: 0,
      }
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            header: 0,
            defval: '',
            raw: false
          })
          const excellist = []
          // Edit data
          if (ws.length > 0) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < ws.length; i++) {
              excellist.push(ws[i])
            }
          } else {
            this.showToast('File không có dữ liệu', 'XCircleIcon', 'danger', 3000)
            this.resetInputFile()
            return
          }
          if (
            !Object.hasOwn(excellist[0], 'MA_DOT_KHAO_SAT_DANH_GIA')
            || !Object.hasOwn(excellist[0], 'TEN_DOT_KHAO_SAT_DANH_GIA')
            || !Object.hasOwn(excellist[0], 'MA_NHOM_DOI_TUONG_THUC_KHAO_SAT_DANH_GIA')
            || !Object.hasOwn(excellist[0], 'MA_PHIEU_KHAO_SAT_DANH_GIA_TONG_QUAN')
            || !Object.hasOwn(excellist[0], 'NGAY_BAT_DAU')
            || !Object.hasOwn(excellist[0], 'NGAY_KET_THUC')
            || !Object.hasOwn(excellist[0], 'TRANG_THAI')
          ) {
            this.showToast('File chưa đúng định dạng, vui lòng tải file mẫu', 'XCircleIcon', 'danger', 3000)
            this.resetInputFile()
            return
          }
          this.dataExcel = []
          // eslint-disable-next-line no-plusplus
          for (let k = 0; k < excellist.length; k++) {
            const item = excellist[k]
            // eslint-disable-next-line no-bitwise
            if (item.MA_DOT_KHAO_SAT_DANH_GIA.trim() === '' || item.TEN_DOT_KHAO_SAT_DANH_GIA.trim() === '' || item.MA_NHOM_DOI_TUONG_THUC_KHAO_SAT_DANH_GIA.trim() === ''
            || item.MA_PHIEU_KHAO_SAT_DANH_GIA_TONG_QUAN.trim() === '' || String(item.NGAY_BAT_DAU).trim() === '' || String(item.NGAY_KET_THUC).trim() === '' || String(item.TRANG_THAI).trim() === '') {
              this.showToast(`Dữ liệu đầu vào không được trống các trường thông tin [MA_DOT_KHAO_SAT_DANH_GIA, TEN_DOT_KHAO_SAT_DANH_GIA, MA_NHOM_DOI_TUONG_THUC_KHAO_SAT_DANH_GIA, 
              MA_PHIEU_KHAO_SAT_DANH_GIA_TONG_QUAN, NGAY_BAT_DAU, NGAY_KET_THUC, TRANG_THAI], Kiểm tra thông tin dòng ${k + 1}`, 'XCircleIcon', 'danger', 3000)
              this.resetInputFile()
              return
            }
            const obj = {
              rowNum: k + 1,
              code: item.MA_DOT_KHAO_SAT_DANH_GIA,
              name: item.TEN_DOT_KHAO_SAT_DANH_GIA,
              evaluateObjectGroupCode: item.MA_NHOM_DOI_TUONG_THUC_KHAO_SAT_DANH_GIA,
              setOfCriteriaCode: item.MA_PHIEU_KHAO_SAT_DANH_GIA_TONG_QUAN,
              startDate: item.NGAY_BAT_DAU,
              endDate: item.NGAY_KET_THUC, 
              status: item.TRANG_THAI,
            }
            this.dataExcel.push(obj)
          }
          this.showTableImport = true
        } catch (e) {
          alert(`Read failure!${e}`)
        }
      }
      fileReader.readAsBinaryString(files[0])
      return res
    },
    downloadFile() {
      const columns = [
        { index: 1, width: 100 },
        { index: 2, width: 300 },
        { index: 3, width: 100 },
        { index: 4, width: 100 },
        { index: 5, width: 100 },
        { index: 6, width: 100 },
        { index: 7, width: 50 },
      ]
      const rows = []
      const headerRow = {
        index: 1,
        cells: [
          {
            index: 1,
            value: 'MA_DOT_KHAO_SAT_DANH_GIA',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 2,
            value: 'TEN_DOT_KHAO_SAT_DANH_GIA',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 3,
            value: 'MA_NHOM_DOI_TUONG_THUC_KHAO_SAT_DANH_GIA',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 4,
            value: 'MA_PHIEU_KHAO_SAT_DANH_GIA_TONG_QUAN',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 5,
            value: 'NGAY_BAT_DAU',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 6,
            value: 'NGAY_KET_THUC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
          {
            index: 7,
            value: 'TRANG_THAI',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              fontColor: '#ffffff',
              backColor: '#000000',
            },
          },
        ],
      }
      const headerRow1 = {
        index: 2,
        cells: [
          {
            index: 1,
            value: 'D1',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 2,
            value: 'Đợt 1',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 3,
            value: 'SVLTC',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 4,
            value: 'DGLTC2024',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 5,
            value: '2024-06-09',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 6,
            value: '2024-07-16',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 7,
            value: 1,
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
        ],
      }
      const headerRow2 = {
        index: 3,
        cells: [
          {
            index: 1,
            value: 'D2',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 2,
            value: 'Đợt 2',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 3,
            value: 'SVGVCB',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 4,
            value: 'KSCLDV2025',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 5,
            value: '2024-06-05',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 6,
            value: '2024-07-25',
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
          {
            index: 7,
            value: 0,
            colSpan: 1,
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
            },
          },
        ],
      }

      const headerRow4 = {
        index: 5,
        cells: [
          {
            index: 1,
            colSpan: 1,
          },
          {
            index: 2,
            colSpan: 1,
          },
          {
            index: 3,
            colSpan: 1,
          },
          {
            index: 4,
            colSpan: 1,
          },
          {
            index: 5,
            colSpan: 1,
          },
          {
            index: 6,
            colSpan: 1,
          },
          {
            index: 7,
            value: '1: Hoạt động, 0: Không hoạt động',
            colSpan: 1,
          },
        ],
      }

      rows.push(headerRow)
      rows.push(headerRow1)
      rows.push(headerRow2)
      rows.push(headerRow4)
      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save('dotKhaoSat.xlsx')
    },
    exportExcel() {
      if (this.dataResourecesExport.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có dữ liệu để xuất!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }

      let excelData = []
      let data = []
      this.dataResourecesExport.forEach((item) => {
        data.push({ 'code': item.code, 'name': item.name, 'evaluateObjectGroupName': item.evaluateObjectGroupName, 'setOfCriteriaName': item.setOfCriteriaName, 'startDate': item.startDate, 'endDate': item.endDate, 'status': this.getStatusName(item.status) })
      })

      const header = {}
      this.columnsExport.forEach(column => {
        header[column.field] = column.label
      })

      const headerKeys = Object.keys(header)
      const dataSourceKeys = Object.keys(data[0])
      const duplicates = dataSourceKeys.filter(val => headerKeys.includes(val))
      duplicates.sort((a, b) => headerKeys.indexOf(a) - headerKeys.indexOf(b))
      data.forEach(dataSource => {
        const elm = {}
        duplicates.forEach(key => {
          elm[header[key]] = dataSource[key]
        })
        excelData.push(elm)
      })

      const ws = XLSX.utils.json_to_sheet(excelData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'DotKhaoSat')
      XLSX.writeFile(wb, 'DanhSachDotKhaoSat.xlsx')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
